<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-mask`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43.667 6C44.955 6 46 6.895 46 8v32c0 1.105-1.045 2-2.333 2H4.333C3.045 42 2 41.105 2 40V8c0-1.105 1.045-2 2.333-2h39.334zM42 10H6v28h36V10zm-18 4c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 4a6 6 0 100 12 6 6 0 000-12z"/></svg>
</template>
<script>

export default {
  name: 'IconMask',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
